var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-374q-12 0-23.5-4.5T436-392L277-551q-18-18-18-44t18-44q18-18 44-18t44 18l52 52v-244q0-26 18.5-44.5T480-894q26 0 44.5 18.5T543-831v244l52-52q18-18 44-18t44 18q18 18 18 44t-18 44L524-392q-9 9-20.5 13.5T480-374ZM220-96q-53 0-89.5-36.5T94-222v-118q0-26 18.5-44.5T157-403q26 0 44.5 18.5T220-340v118h518v-118q0-26 18.5-44.5T801-403q26 0 44.5 18.5T864-340v118q0 53-36.5 89.5T738-96H220Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDownload);
export default __webpack_public_path__ + "static/media/custom-download.ce088484813dd41878006485b54eca6c.svg";
export { ForwardRef as ReactComponent };